import React from "react";

function MembersIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 21.98 15.386">
      <path
        d="M3.3,8.844a2.2,2.2,0,1,0-2.2-2.2A2.2,2.2,0,0,0,3.3,8.844Zm15.386,0a2.2,2.2,0,1,0-2.2-2.2A2.2,2.2,0,0,0,18.683,8.844Zm1.1,1.1h-2.2a2.192,2.192,0,0,0-1.549.639,5.023,5.023,0,0,1,2.579,3.757h2.267a1.1,1.1,0,0,0,1.1-1.1v-1.1A2.2,2.2,0,0,0,19.782,9.943Zm-8.792,0A3.846,3.846,0,1,0,7.143,6.1,3.844,3.844,0,0,0,10.99,9.943Zm2.638,1.1h-.285a5.311,5.311,0,0,1-4.705,0H8.352A3.957,3.957,0,0,0,4.4,15v.989a1.649,1.649,0,0,0,1.648,1.648h9.891a1.649,1.649,0,0,0,1.648-1.648V15A3.957,3.957,0,0,0,13.627,11.042Zm-7.683-.46A2.192,2.192,0,0,0,4.4,9.943H2.2a2.2,2.2,0,0,0-2.2,2.2v1.1a1.1,1.1,0,0,0,1.1,1.1H3.362A5.036,5.036,0,0,1,5.945,10.582Z"
        transform="translate(0 -2.25)"
      />
    </svg>
  );
}

export { MembersIcon };
